import { createColumnHelper } from '@tanstack/react-table';
import { CashierShiftBalance, useRepositoryQuery } from '@mews-commander/data-access';
import { LocalizedCurrencyValue, lt } from '@mews/framework';
import { Table, TableProvider, useTableState } from '@optimus-web/core';

const helper = createColumnHelper<CashierShiftBalance>();

const tableColumns = [
    helper.accessor('currencyCode', {
        header: () => lt('Currency'),
    }),
    helper.accessor('startingBalance', {
        header: () => lt('CashierShiftStartingBalance'),
        cell: ({ getValue }) => (
            <LocalizedCurrencyValue value={{ value: getValue().value, currency: getValue().currency }} />
        ),
    }),
    helper.accessor('incoming', {
        header: () => lt('CashierShiftIncoming'),
        cell: ({ getValue }) => (
            <LocalizedCurrencyValue value={{ value: getValue().value, currency: getValue().currency }} />
        ),
    }),
    helper.accessor('outgoing', {
        header: () => lt('CashierShiftOutgoing'),
        cell: ({ getValue }) => (
            <LocalizedCurrencyValue value={{ value: getValue().value, currency: getValue().currency }} />
        ),
    }),
    helper.accessor('balance', {
        header: () => lt('Balance'),
        cell: ({ getValue }) => (
            <LocalizedCurrencyValue value={{ value: getValue().value, currency: getValue().currency }} />
        ),
    }),
];

interface Props {
    cashierId: string;
    shiftId?: string;
}

export const ShiftOverviewTable = ({ shiftId, cashierId }: Props) => {
    const { data, isFetching } = useRepositoryQuery('cashiers', 'getShift', {
        cashierId,
        shiftId,
    });

    const [tableState, setTableState] = useTableState<CashierShiftBalance>({
        pagination: {
            show: false,
        },
    });

    const shiftBalances = data?.shiftBalances ?? [];

    return (
        <TableProvider columns={tableColumns} state={tableState} onStateChange={setTableState}>
            <Table
                data-test-id="shift-overview-table"
                loading={isFetching}
                uniqueRowId="currencyCode"
                data={shiftBalances}
                amountOfRows={shiftBalances.length}
            />
        </TableProvider>
    );
};
